<template>
    <div>
        <customer-base
            :detail.sync="customerDetail"
            :geoHierarchyData="geoHierarchyData"
            :provinceArray="provinceArray"
            :objUser="userDetail"
            @refreshUser="fetchListUser"
            customerType="customer"
        />
        <modal-add-customer
            :dialogShow="dialogShowAddUser"
            @closeModal="dialogShowAddUser = false"
            v-on:refreshTable="fetchListUser"
            ></modal-add-customer>
        <h1 style="margin-top:unset;">Customer Detail</h1>
        <el-row :gutter="20">
            <el-col :md="12" :xs="24">
                <el-card shadow="never">
                    <h2 style="margin-top:unset;">ข้อมูลผู้ใช้งานระบบ</h2>
                    <div style="text-align:left;margin-bottom:5px;">
                        <el-button style="background-color:#00796B;color:#fff;" @click="dialogShowAddUser = !dialogShowAddUser">สร้างผู้ใช้งานและร้านค้า</el-button>
                    </div>
                    <el-row>
                        <el-col class="text-md-left" :sm="24">
                            <el-form :inline="true" @submit.native.prevent="() => {}">
                                <el-row>
                                    <el-col :xs="24" :xl="12">
                                        <el-input
                                            placeholder="ค้นหา"
                                            clearable
                                            @input="onSearchCustomer()"
                                            @keyup.enter="onSearchCustomer"
                                            v-model="searchText">
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input>
                                    </el-col>
                                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6" class="btn-search-box">
                                        <el-form-item>
                                            <el-button type="primary" @click="fetchListUser">เรียกข้อมูล</el-button>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6" class="second-box">
                                        <FilterDropdown
                                        ref="dropdownParent"
                                        :filterDropdownCase.sync="filterDropdownCase"
                                        :isOpenFilterDropdown="isOpenFilterDropdown"
                                        :handleChangeVisibility="handleChangeVisibility"
                                    >
                                            <template v-slot:closeFilter>
                                                <el-button @click="closeFilter" style="width:100%">
                                                    Cancel
                                                </el-button>
                                            </template>
                                            <template v-slot:searchFilter>
                                                <el-button type="primary" style="width:100%" @click="onSearchCustomer">
                                                    Submit
                                                </el-button>
                                            </template>
                                        </FilterDropdown>
                                        <div class="btn-export-box">
                                            <el-button type="primary" class="btn-export" @click="isDialogExportCustomer = true">Export</el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="text-md-left" :sm="24">
                            <el-table
                                v-loading="loadingTable"
                                :data="userList"
                                stripe
                                :default-sort = "{prop: 'createdAt', order: 'descending'}"
                                :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                style="width: 100%"
                                ref="customerTable"
                                row-key="userId"
                                @selection-change="handleSelectionChange">
                                <el-table-column v-model="customerSelection" :reserve-selection="true" type="selection" align="center" width="55" />
                                <el-table-column fixed prop="userCode"  label="รหัสลูกค้า" width="100"></el-table-column>
                                <el-table-column fixed prop="Activate" label="Activate" width="80">
                                    <div class="text-md-left" slot-scope="scope">
                                        <i :style="{'color' : scope.row.isActivate ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isActivate, 'el-icon-close': !scope.row.isActivate}"></i>
                                    </div>
                                </el-table-column>
                                <el-table-column  label="ชื่อลูกค้า" width="200">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{scope.row.firstName}} {{scope.row.lastName}}
                                    </div>
                                </el-table-column>
                                <el-table-column prop="email" label="อีเมล์" min-width="200"></el-table-column>
                                <el-table-column prop="phoneNumber" label="เบอร์โทรลูกค้า" width="150"></el-table-column>
                                <el-table-column prop="isVerify" label="ยืนยัน">
                                    <div class="text-md-left" slot-scope="scope">
                                        <i :style="{'color' : scope.row.isVerify ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isVerify, 'el-icon-close': !scope.row.isVerify}"></i>
                                    </div>
                                </el-table-column>

                                <el-table-column prop="isEmailVerify" label="ยืนยันอีเมล์" width="100">
                                    <div class="text-md-left" slot-scope="scope">
                                        <i :style="{'color' : scope.row.isEmailVerify ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isEmailVerify, 'el-icon-close': !scope.row.isEmailVerify}"></i>
                                    </div>
                                </el-table-column>

                                <el-table-column  label="สถานะแพ็คเกจ" width="150">
                                    <div class="text-md-left" slot-scope="scope" >
                                        {{getSubscriptionStatusLabel(scope.row.subscriptionStatus)}}
                                    </div>
                                </el-table-column>

                                <el-table-column  label="สถานะการจ่ายเงิน"  width="150">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{getSubscriptionPaymentStatusLabel(scope.row.subscriptionStatus)}}
                                    </div>
                                </el-table-column>

                                <el-table-column prop="createdAt" label="สร้างเมื่อ" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.createdAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}
                                    </template>
                                </el-table-column>

                                <el-table-column fixed="right" label="จัดการ" width="150">
                                    <template slot-scope="scope">
                                        <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="warning" plain @click="showUserDetail(scope.row)"></el-button>
                                        <el-button :key="scope.$index+'-shop'" size="small" icon="el-icon-document" type="info" plain @click="showShop(scope.row)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                        <el-col style="margin-top:10px;">
                            <el-pagination
                                @size-change="changeLimitPage"
                                @current-change="changeCurrentPage"
                                :current-page.sync="pagination.currentPage"
                                :page-sizes="pagination.pageSizes"
                                :page-size="10"
                                layout="prev, pager, next, sizes"
                                :total="pagination.allPage * pagination.limit">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :md="12">
                <el-card shadow="never">
                    <h2 style="margin-top:unset;">ข้อมูลร้านค้า</h2>
                    <shop-data-table :userID="selUserID"
                    :userInfo="selUser"
                    :componentKey="componentKey"
                    @setUserId="selUserID = ''"
                    :geoHierarchyData="geoHierarchyData"
                    :provinceArray="provinceArray"
                    :zipcodeArray="zipcodeArray"
                    ></shop-data-table>
                </el-card>
            </el-col>
        </el-row>
        <dialog-export-customer
            :isDialogExportCustomer="isDialogExportCustomer"
            :customerSelected="customerSelection"
            :customerFilter="filterDropdownCase"
            :searchTextForFilter="searchText"
            customerType="customer"
            @onCloseDialog="isDialogExportCustomer = false"
            @onExportSuccess="$refs.customerTable.clearSelection()" />
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import ModalAddCustomer from '@/components/Customer/ModalAddCustomer'
import ShopDataTable from '@/components/Shop/ShopTable'
import mixinExcel from '@/mixins/exportExcel.js'
import onlineOperationUtility from '@/mixins/onlineOperationUtility.js'
import CustomerBase from '@/components/Customer/CustomerBase'
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown'
import DialogExportCustomer from '@/components/helper/DialogExportCustomer.vue'

export default {
    name: 'CustomerDetail',
    mixins: [mixinExcel, onlineOperationUtility],
    components: {
        ModalAddCustomer,
        ShopDataTable,
        CustomerBase,
        FilterDropdown,
        DialogExportCustomer
    },
    data () {
        return {
            searchText: '',
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            filterDropdownCase: {
                package_code: null,
                subscription_type: null,
                account_status: null,
                expire_within: false
            },
            isOpenFilterDropdown: false,
            userList: [],
            loadingTable: false,
            dialogShow: false,
            dialogShowAddUser: false,
            userDetail: null,
            selUserID: '',
            selUser: {
                userCode: '-', userName: '-'
            },
            customerStatusFillter: 1,
            componentKey: 0,
            timeoutSearch: null,
            customerDetail: {
                dialog: false,
                data: {},
                operationTag: [],
                pickupAddressShop: [],
                isSelectAddress: false,
                isCheckDelete: false,
                isCheckEditBooking: false
            },
            geoHierarchyData: {},
            provinceArray: [],
            zipcodeArray: [],
            baseSubscriptionData: {},
            isDialogExportCustomer: false,
            customerSelection: []
        }
    },
    created () {
        let zipcodeArr = []
        let geoJsonData = require('@/assets/geo.json')
        geoJsonData.forEach(e => {
            if (!(e['province'] in this.geoHierarchyData)) {
                this.geoHierarchyData[e['province']] = {}
            }
            if (!(e['amphoe'] in this.geoHierarchyData[e['province']])) {
                this.geoHierarchyData[e['province']][e['amphoe']] = {}
            }
            if (
                !(
                    e['district'] in
                    this.geoHierarchyData[e['province']][e['amphoe']]
                )
            ) {
                this.geoHierarchyData[e['province']][e['amphoe']][e['district']] = e['zipcode']
                if (e['zipcode']) {
                    zipcodeArr.push(String(e['zipcode']))
                }
            }
        })
        for (let provice in this.geoHierarchyData) {
            this.provinceArray.push(provice)
        }
        zipcodeArr = [...new Set(zipcodeArr)]
        this.zipcodeArray = zipcodeArr.sort()
        this.fetchListUser()
    },
    methods: {
        print () {
            console.log(this.filterDropdownCase)
        },
        closeFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
        },
        handleChangeVisibility (value) {
            this.isOpenFilterDropdown = value
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchListUser()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchListUser()
        },
        onFilterCustomerStatus () {
            this.pagination = {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }
            this.fetchListUser()
        },
        onSearchCustomer () {
            this.pagination.currentPage = 1
            this.pagination.offset = 0
            this.fetchListUser()
            this.closeFilter()
            this.$refs.customerTable.clearSelection()
        },
        fetchListUser () {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    // filter_status: this.customerStatusFillter,
                    // is_activate: true,
                    // is_approve: true
                    expire_within: this.filterDropdownCase.expire_within ? 7 : null,
                    account_status: this.filterDropdownCase.account_status,
                    subscription_type: this.filterDropdownCase.subscription_type,
                    package_code: this.filterDropdownCase.package_code
                }
                // let res = await fgApi.user.getUserListOpt(param)
                let res = await fgApi.user.searchApprovedUser(param)
                if (res.success) {
                    if (this.searchText === param.search) {
                        this.userList = res.data
                        this.pagination.allPage = res.allPage
                    }
                }
                this.loadingTable = false
            }, 1000)
        },
        async showUserDetail (row) {
            this.customerDetail.dialog = !this.customerDetail.dialog
            await this.onGetSubscription(row.userId)
            this.customerDetail.data = { ...row, ...this.baseSubscriptionData }
            this.customerDetail.operationTag = []
            let param = {
                user_id: row.userId
            }
            try {
                let getAllPickupAddress = await fgApi.user.getAllPickupAddressShop(param)
                if (getAllPickupAddress.success) {
                    this.customerDetail.pickupAddressShop = getAllPickupAddress.data
                }
                let operationTagRes = await fgApi.log.getOperationCancelTag(param)
                if (operationTagRes.success) {
                    for (let calcelOnline in operationTagRes.data) {
                        this.customerDetail.operationTag.push(this.getOperationTag(operationTagRes.data[calcelOnline]))
                    }
                } else {
                    alert(operationTagRes.message)
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        showShop (row) {
            this.componentKey += 1
            this.selUserID = row.userId
            this.selUser.userCode = row.userCode
            this.selUser.userName = `${row.firstName} ${row.lastName}`
        },
        closeDialogCustomer () {
            this.customerDetail.dialog = !this.customerDetail.dialog
            this.customerDetail.data = { }
        },
        async onGetSubscription (userId) {
            try {
                const param = {
                    userId: userId
                }

                const res = await fgApi.subscription.getSubscription(param)

                const convertToPropsData = {
                    subscriptionData: { ...res.data }
                }

                this.baseSubscriptionData = convertToPropsData
            } catch (error) {
                const convertToPropsData = {
                    subscriptionData: null
                }

                this.baseSubscriptionData = convertToPropsData
            }
        },
        handleSelectionChange (val) {
            this.customerSelection = val
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-search-box {
    display: flex;
    justify-content: flex-start;
    @media only screen and (min-width: 1920px) {
        padding-left: 16px;
    }
    @media only screen and (max-width: 1919px) {
        margin-top: 16px;
    }
}
.second-box {
        display: flex;
        justify-content: flex-end;
        .btn-export-box {
            margin-left: 16px;
            .btn-export {
                width: 90px;
                height: 40px;
            }
        }
        @media only screen and (max-width: 1919px) {
            margin-top: 16px;
        }
    }
</style>
